import React, { InputEvent, useState } from "react";
import BasicInput from "./BasicInput";

function AuthLabeledTextInput({
  setValue,
  numbersOnly,
  maxLength,
  minLength,
  onInput,
  name,
  label,
  testId,
  className,
  inputClassName,
  inputMode,
  placeholder,
  value,
  pattern,
  required,
  defaultValue,
  autoFocus,
  showValidation,
  disabled,
  list,
}: {
  setValue?: (value: string) => void;
  numbersOnly?: boolean;
  maxLength?: number;
  minLength?: number;
  onInput?: (e: InputEvent) => void;
  name?: string;
  label: string;
  testId?: string;
  className?: string;
  inputClassName?: string;
  inputMode?: string;
  placeholder?: string;
  value?: unknown;
  pattern?: string;
  required?: boolean;
  defaultValue?: string;
  autoFocus?: boolean;
  showValidation?: boolean;
  disabled?: boolean;
  list?: string;
}) {
  const [validationMessage, setValidationMessage] = useState<string | null>(
    null,
  );
  const onChange = (value: string) => {
    if (typeof setValue === "function") {
      const re = /^[0-9\b]+$/;
      if (numbersOnly) {
        if (value === "" || re.test(value)) {
          setValue(value);
        }
      } else {
        setValue(value);
      }
    }
  };

  const internalOnInput = (e: InputEvent) => {
    if (typeof onInput === "function") {
      onInput(e);
    }
    const target = e.nativeEvent.target! as HTMLInputElement;
    setValidationMessage(
      target.validity.valid ? null : target.validationMessage,
    );
  };
  const testIdKey = testId ?? name ?? label;

  return (
    <>
      <label className={`text-sm my-2 block ${className}`}>
        {label}
        <BasicInput
          disabled={disabled}
          type={inputMode || "text"}
          maxLength={maxLength}
          minLength={minLength}
          onChange={onChange}
          placeholder={placeholder}
          value={value}
          name={name}
          pattern={pattern}
          onInput={internalOnInput}
          required={required ?? false}
          testId={testIdKey}
          defaultValue={defaultValue}
          autoFocus={autoFocus}
          className={inputClassName}
          label={undefined}
          step={undefined}
          onClick={undefined}
          // @ts-expect-error: BasicInput is not typed yet
          list={list}
        />
        {showValidation ?? true ? (
          <div
            style={{ display: validationMessage === null ? "none" : "block" }}
            className="text-snow-red text-sm"
            data-testid={testIdKey + "-validation-message"}
          >
            {validationMessage}
          </div>
        ) : null}
      </label>
    </>
  );
}

export default AuthLabeledTextInput;
